"use client";

import { SLATE_XP_REDRAWN_ICONS_BETA } from "@faire/web/slate/icons/lib/SLATE_XP_REDRAWN_ICONS";

import {
  Arrow as ArrowControl,
  ArrowLeft as ArrowLeftControl,
  ArrowRight as ArrowRightControl,
  ArrowUp as ArrowUpControl,
  ArrowUpAndRight as ArrowUpAndRightControl,
  ArrowDown as ArrowDownControl,
} from "./__internal__/Arrow.control";
import {
  Arrow as ArrowTreatment,
  ArrowLeft as ArrowLeftTreatment,
  ArrowRight as ArrowRightTreatment,
  ArrowUp as ArrowUpTreatment,
  ArrowUpAndRight as ArrowUpAndRightTreatment,
  ArrowDown as ArrowDownTreatment,
} from "./__internal__/Arrow.treatment";

export const Arrow = SLATE_XP_REDRAWN_ICONS_BETA.icon({
  control: ArrowControl,
  treatment: ArrowTreatment,
});

/**
 * @deprecated use ArrowLeft from `@faire/slate/icons/ArrowLeft`
 * @trackcomponent
 */
export const ArrowLeft = SLATE_XP_REDRAWN_ICONS_BETA.icon({
  control: ArrowLeftControl,
  treatment: ArrowLeftTreatment,
});

/**
 * @deprecated use ArrowUp from `@faire/slate/icons/ArrowUp`
 * @trackcomponent
 */
export const ArrowUp = SLATE_XP_REDRAWN_ICONS_BETA.icon({
  control: ArrowUpControl,
  treatment: ArrowUpTreatment,
});

/**
 * @deprecated use ArrowDown from `@faire/slate/icons/ArrowDown`
 * @trackcomponent
 */
export const ArrowDown = SLATE_XP_REDRAWN_ICONS_BETA.icon({
  control: ArrowDownControl,
  treatment: ArrowDownTreatment,
});

/**
 * @deprecated use ArrowRight from `@faire/slate/icons/ArrowRight`
 * @trackcomponent
 */
export const ArrowRight = SLATE_XP_REDRAWN_ICONS_BETA.icon({
  control: ArrowRightControl,
  treatment: ArrowRightTreatment,
});

/**
 * @deprecated use ArrowUpAndRight from `@faire/slate/icons/ArrowUpAndRight`
 * @trackcomponent
 */
export const ArrowUpAndRight = SLATE_XP_REDRAWN_ICONS_BETA.icon({
  control: ArrowUpAndRightControl,
  treatment: ArrowUpAndRightTreatment,
});
